module.exports = __webpack_public_path__ + "static/img/伙伴客户-上海仁济.20ab7743.png";